// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 47) return "client-472f49518c3b3bd40ae0.css";
	// return url for filenames based on template
	return "" + chunkId + ".css";
};